import styled, { css } from 'styled-components';

export const CardWrapper = styled.div<any>`
  /* max-width: 168px; */
  display: flex !important;
  flex-direction: column;
  height: 100%;
  text-align: left;
  position: relative;
  user-select: none;

  .img-box {
    width: 100%;
    width: 100%;
    height: 168px;
    margin-bottom: 12px;
    position: relative;
    overflow: hidden;
    > div,
    > span {
      position: static !important;
      width: 100% !important;
      height: 100% !important;
      /* padding: 4px  !important; */
    }
    .img {
      position: unset !important;
    }
    .sale {
      position: absolute;
      right: -26px;
      bottom: 12px;
      font-size: 12px;
      font-weight: 800;
      background: #EA5651;
      color: #fff;
      width: 92px;
      text-align: center;
      line-height: 20px;
      transform: rotate(-50deg);
      
    }
  }
  .info {
    color: var(--textDark);
    margin-bottom: 8px;

    .prices {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .price {
        font-size: 16px;
        font-weight: 700;
      }
      .old-price {
        color: #666666;
        font-size: 14px;
        text-decoration: line-through;
        margin-left: 12px;
        font-weight: 400;
      }
    }

    .title a {
      text-transform: initial;
      line-height: 1.44;
      font-size: 14px;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-weight: 400;
      transition: 0.5s;

      word-wrap: break-all;
      max-width: 100%;

      :hover {
        color: var(--hyperlink);
      }
    }
    .rating {
      margin-top: 6px;
      display: flex;
      span {
        margin-right: 4px;
      }
      svg {
        height: 11px;
        width: auto;
        display: block;
      }
    }
  }
  /* flex end _______________ */
  .end {
    margin-top: auto;
  }
  
  .actions {
    position: absolute;
    z-index: 10;
    top: 12px;
    right: 16px;

    button,a {
      transition: 0.5s;
      display: block;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      background-color: #fff;
      margin-bottom: 8px;
      text-align: center;
      svg {
        width: 14px;
        height: 100%;
        color: #000;
      }
    }
  }
  .free-delivery {
    font-size: 12px;
    line-height: 1;
    color: var(--hyperlink);
    font-weight: 700;
    display: flex;
    align-items: center;
    svg {
      margin-right: 6px;
      width: 12px;
      height: auto;
      margin-top: 2px;
    }
  }
  .author {
    line-height: 32px;
    background-color: #ECEFF1;
    border-radius: 4px;
    padding: 0 6px;
    font-size: 12px;
    font-weight: 500;
    width: max-content;
    margin-bottom: 8px;
  }

  @media screen and (max-width: 1160px) {
    user-select: none;
    .info {
      .prices {
        align-items: flex-start;
        margin-bottom: 4px;
        .price {
          font-size: 14px;
        }
        .old-price {
          font-size: 12px;
          margin-left: 8px;
        }
      }
    }
  }
  @media screen and (max-width: 740px) {

    .info {
      margin-bottom: 4px;
      .rating {
        margin-top: 2px;
      }
      .title a {
        font-size: 12px;
        line-height: 1.8;
      }
      .free-delivery {
        font-size: 10px;
        margin-top: 4px;
      }
    }
    .actions {
      top: 12px;
      right: 12px;
    }
  }
`;
